export const AirConditioning = {
  None: 0,
  BlowsCold: 1,
  NotWorking: 2,
  NoAc: 3,
}
